var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.8144,
    cy: 32.7365,
    r: 31.8144,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0159 25.2452C25.0159 24.4825 25.6343 23.8641 26.3971 23.8641L40.0697 23.8641C40.8325 23.8641 41.4509 24.4825 41.4509 25.2452L41.4509 38.9179C41.4509 39.6806 40.8325 40.299 40.0697 40.299C39.307 40.299 38.6886 39.6806 38.6886 38.9179V28.5796L25.4205 41.8477C24.8811 42.3871 24.0066 42.3871 23.4672 41.8477C22.9278 41.3083 22.9279 40.4339 23.4672 39.8945L36.7354 26.6264L26.3971 26.6264C25.6343 26.6263 25.016 26.008 25.0159 25.2452Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.e0dbf7c2e6f492a57bdd141f5dab76ca.svg";
export { ForwardRef as ReactComponent };